import { Flex } from "@chakra-ui/layout";
import { SizeSearchMobile } from "./SizeSearch";
import { VehicleSearchMobile } from "./VehicleSearch";
import { useState } from "react";
import { Spinner } from "@chakra-ui/react";

type SearchProps = {
  loading?: boolean;
};

export function SearchBarMobile({ loading }: SearchProps) {
  const [loadingSearchSize, setLoadingSearchSize] = useState<boolean>(false);

  function loadingToogleSize() {
    setLoadingSearchSize(true);
  }

  const [loadingSearchVehicle, setLoadingSearchSizeVehicle] = useState<boolean>(false);

  function loadingToogleSizeVehicle() {
    setLoadingSearchSizeVehicle(true);
  }

  return (
    <>
      <Flex display={["Flex", "none"]} w="full" h="full" direction="column" px={"10px"} mt={"10px"}>
        <Flex
          mb="1rem"
          p="1rem"
          direction="column"
          bgColor="ll-white.main"
          align="center"
          justify="start"
          w="full"
          h="full"
          borderRadius="5px"
          border={"1px solid"}
          borderColor={"ll-gray.100"}
        >
          {loadingSearchSize && (
            <Flex
              w={"full"}
              h={"140px"}
              position={"absolute"}
              zIndex={2}
              bgColor={"#ffffff8c"}
              justifyContent={"center"}
              alignItems={"center"}
              cursor={"wait"}
            >
              <Spinner
                thickness="4px"
                speed="0.65s"
                emptyColor="gray.200"
                color="blue.500"
                size="xl"
              />
            </Flex>
          )}
          <SizeSearchMobile loading={loading} loadingAnim={loadingToogleSize} />
        </Flex>

        <Flex
          p="1rem"
          direction="column"
          bgColor="ll-white.main"
          align="center"
          justify="start"
          w="full"
          h="full"
          borderRadius="5px"
          border={"1px solid"}
          borderColor={"ll-gray.100"}
        >
          {loadingSearchVehicle && (
            <Flex
              w={"full"}
              h={"220px"}
              position={"absolute"}
              zIndex={2}
              bgColor={"#ffffff8c"}
              justifyContent={"center"}
              alignItems={"center"}
              cursor={"wait"}
            >
              <Spinner
                thickness="4px"
                speed="0.65s"
                emptyColor="gray.200"
                color="blue.500"
                size="xl"
              />
            </Flex>
          )}

          <VehicleSearchMobile loading={loading} loadingAnim={loadingToogleSizeVehicle} />
        </Flex>
      </Flex>
    </>
  );
}
